<template lang='pug'>
.exchange-record-container
    van-tabs.tab-inner-wrapper(type="line" :border="false")
        van-tab(title="全部")
            OrderList.list(:orderList="orders | filterType('all')")
        van-tab(title="待发货")
            OrderList.list(:orderList="orders | filterType(false)")
        van-tab(title="已发货")
            OrderList.list(:orderList="orders | filterType(true)")
</template>

<script>
import { mapState } from 'vuex'
import OrderList from '../components/orderList'
export default {
    components: {
        OrderList
    },
    filters: {
        filterType: function (arr, type) {
            if (!arr) return []
            if(type==='all') return arr
            return arr.filter(item => item.status.isShipped === type)
        }
    },
    computed: {
        ...mapState(['memberInfo']),
        orders() {
            const orders = this.memberInfo.orders
            if (!orders) return []
            return orders
        }
    }
}
</script>

<style scoped lang='less'>
</style>